module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-t-sm m-b-sm"
  }, [_c('button', {
    staticClass: "btn btn-default font-bold btnlock",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v(_vm._s(_vm.show ? 'Cancelar' : 'Alterar status da GRV'))])]), _vm._v(" "), (_vm.show) ? _c('popup-viewer-alert', {
    attrs: {
      "title": "Alteração manual de status da GRV"
    }
  }, [_c('div', {
    staticClass: "form-group m-t-sm"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStatus),
      expression: "newStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o novo status")]), _vm._v(" "), _vm._l((_vm.lista), function(status, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(status.titulo))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default m-l",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "type": "button",
      "disabled": _vm.newStatus === null
    },
    on: {
      "click": _vm.setNewStatus
    }
  }, [_vm._v("Confirmar")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7de5950","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/BtnAlteraStatusGrv.vue
// module id = 2077
// module chunks = 18